import {
  Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent,
  DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, Typography
} from '@material-ui/core';
import { Assignment } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useCallback, useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import {
  useQuizAssessmentTestDataProvider
} from "../../../providers/data-provider/quiz-assessment-test.data.provider";

const useStyles = makeStyles(() => ({
  headerCell: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  bodyCell: {
    whiteSpace: 'nowrap',
  },
}));

const ANSWER_OPTIONS = ['A', 'B', 'C', 'D', 'E'];
const BLANK_ANSWER = 'blank';

export function SaveResultsAction({ testId, userContextId, studentName, status, onSubmitted }) {
  const classes = useStyles();
  const notify = useNotify();
  const [givenAnswers, setGivenAnswers] = useState({});
  const [answerKey, setAnswerKey] = useState([]);
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getTestAnswerKey, correctTest } = useQuizAssessmentTestDataProvider()

  useEffect(() => {
    if (!open) {
      setAnswerKey([]);
      return;
    }
    setGivenAnswers({});
    setLoading(true);
    getTestAnswerKey(testId)
      .then(res => {
        setAnswerKey(res.data)
      })
      .catch(() => {
        notify('Erro ao carregar o gabarito', 'warning');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [open, testId]);

  const handleSubmit = useCallback((testeId, userContextId, answers) => {
    const response = Object.keys(answers).map(questionId => {
      const isBlank = answers[questionId] === BLANK_ANSWER;
      return { questionId, optionId: isBlank ? null : answers[questionId], isBlank };
    });
    setSubmitting(true);
    correctTest(testeId, userContextId, response).then(() => {
      notify('Resultado salvo com sucesso !', 'success');
      setOpen(false);
      onSubmitted?.();
    }).catch(() => {
      notify('Erro ao salvar resultados !', 'error');
    }).finally(() => {
      setSubmitting(false);
    });

  }, [correctTest, notify, onSubmitted])

  const allQuestionsAnswered = answerKey.length > 0
    && answerKey.every((question) => givenAnswers[question.questionId] != null);

  if (status !== 'started') {
    return null;
  }
  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<Assignment />}
        onClick={() => setOpen(true)}
      >
        Salvar Resultados
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Gabarito{studentName ? ` - ${studentName}` : ''}</DialogTitle>
        <DialogContent>
          {loading ? (
            <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" gridGap={16} minHeight={200}>
              <CircularProgress />
              <Typography variant="body2" color="textSecondary">Carregando gabarito</Typography>
            </Box>
          ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Questão</TableCell>
                {ANSWER_OPTIONS.map((letter) => (
                  <TableCell key={letter} className={classes.headerCell} align="center">
                    {letter}
                  </TableCell>
                ))}
                <TableCell className={classes.headerCell} align="center">Em Branco</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {answerKey.map((question) => (
                <TableRow key={question.questionId}>
                  <TableCell className={classes.headerCell}>
                    <Typography variant="body2">{question.questionNumber} - {question.shortQuestion}</Typography>
                  </TableCell>
                  {
                    ANSWER_OPTIONS.map((letter,idx) => {
                      if (idx > question.options?.length - 1) {
                        return (
                          <TableCell key={question.id + letter} className={classes.bodyCell} align="center">
                            <Box display="flex" alignItems="center" justifyContent="center">
                              <Checkbox
                                color={'secondary'}
                                disabled
                              />
                            </Box>
                          </TableCell>
                        )
                      }
                      const opt = question.options[idx];
                      return (
                        <TableCell key={opt.id} className={classes.bodyCell} align="center">
                          <Box display="flex" alignItems="center" justifyContent="center">
                            <Checkbox
                                checked={givenAnswers[question.questionId] === opt.id}
                                // color={givenAnswers[question.questionId] === opt.id ? 'secondary' : 'primary'}
                                onChange={(evt) => {
                                  setGivenAnswers({ ...givenAnswers, [question.questionId]: opt.id });
                                }}
                            />
                          </Box>
                        </TableCell>
                      )
                    })
                  }
                  <TableCell className={classes.bodyCell} align="center">
                    <Box display="flex" alignItems="center" justifyContent="center">
                      <Checkbox
                        checked={givenAnswers[question.questionId] === BLANK_ANSWER}
                        onChange={() => {
                          setGivenAnswers({ ...givenAnswers, [question.questionId]: BLANK_ANSWER });
                        }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="default" disabled={submitting}>
            Fechar
          </Button>
          <Button
            onClick={() => handleSubmit(testId, userContextId, givenAnswers)}
            color="primary"
            variant="contained"
            disabled={submitting || !allQuestionsAnswered}
            startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
          >
            Salvar Respostas
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
